import React from 'react';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';


const BgVideo = ({ style, show, duration, sourceMp4, sourceWebm, verticalAlign, autoPlay, videoRef, onVideoReady, onTimeUpdate }) => {
  const transitionStyles = {
    exiting: { opacity: 1 },
    exited: { opacity: 0 },
  };

  let alignmentStyles;
  switch (verticalAlign) {
    case 'top':
      alignmentStyles = {
        top: 0,
        bottom: 'unset',
        transform: 'translate(calc(-50% - 1px), 0)',
      };
      break;
    case 'bottom':
      alignmentStyles = {
        top: 'unset',
        bottom: 0,
        transform: 'translate(calc(-50% - 1px), 0)',
      };
      break;
    default:
      // centered
      alignmentStyles = {
        top: '50%',
        transform: 'translate(calc(-50% - 1px), calc(-50% - 1px))',
      };
      break;
  }

  return (
    <Transition in={show} timeout={0} appear>
      {state => (
        <video
          muted
          autoPlay={autoPlay}
          playsInline
          className="cover-bg-video"
          style={{ ...style, ...alignmentStyles, transition: `opacity ${duration}ms linear`, ...transitionStyles[state] }}
          ref={node => videoRef(node)}
          onCanPlayThrough={() => onVideoReady()}
          onTimeUpdate={e => onTimeUpdate(e)}
        >
          {sourceWebm ? <source src={sourceWebm} type="video/webm" /> : null}
          {sourceMp4 ? <source src={sourceMp4} type="video/mp4" /> : null}
        </video>
      )}
    </Transition>
  );
};

BgVideo.propTypes = {
  show: PropTypes.bool,
  duration: PropTypes.number,
  sourceMp4: PropTypes.string,
  sourceWebm: PropTypes.string,
  verticalAlign: PropTypes.oneOf(['top', 'center', 'bottom']),
  autoPlay: PropTypes.bool,
  videoRef: PropTypes.func,
  onVideoReady: PropTypes.func,
  onTimeUpdate: PropTypes.func,
};

BgVideo.defaultProps = {
  autoPlay: true,
  videoRef: () => {},
  onVideoReady: () => {},
  onTimeUpdate: () => {},
};

export default BgVideo;



// WEBPACK FOOTER //
// ./src/components/Covers/BgVideo.js